<template>
  <div>
    <div>
      <div>
        <!-- /End replace -->
      </div>
      <div class="container">
        <div
          class="row justify-content-center mt-3"
          style="text-align: center;"
        >
          <div class="col-md-12 mt-4">
            <h3>Add Face Scan</h3>
          </div>
          <div class="col-md-12 mt-4">
            <b-input
              type="email"
              v-model="email"
              placeholder="CMU Email (e.g. user@cmu.ac.th)"
            ></b-input>
            <b-button
              variant="primary"
              @click.prevent="addFacescan"
              class="gobutton"
              :disabled="isLoading"
            >
              <span v-if="isLoading">
                <b-spinner small></b-spinner>
                Adding...
              </span>
              <span v-else>Add Face Scan</span>
            </b-button>
          </div>
          <b-alert
            v-model="showAlert"
            dismissible
            :variant="alertVariant"
            class="mt-3"
          >
            {{ alertMessage }}
          </b-alert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AddFacescan",
  components: {},
  data() {
    return {
      email: "",
      showAlert: false,
      alertVariant: "danger",
      alertMessage: "",
      isLoading: false,
    };
  },
  mounted() {},
  created() {},
  computed: {
    ...mapState({
      user: "user",
    }),
  },
  methods: {
    addFacescan() {
      if (!this.email) {
        this.showAlert = true;
        this.alertVariant = "danger";
        this.alertMessage = "Please enter an email address";
        return;
      }

      // Basic email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.showAlert = true;
        this.alertVariant = "danger";
        this.alertMessage = "Please enter a valid email address";
        return;
      }

      // Check if it's CMU email
      if (!this.email.includes("@cmu.ac.th")) {
        this.showAlert = true;
        this.alertVariant = "danger";
        this.alertMessage = "Only CMU email addresses are allowed (@cmu.ac.th)";
        return;
      }

      this.isLoading = true;
      this.showAlert = false;

      axios
        .post("/api/members/manualaddfacescan", { email: this.email })
        .then((response) => {
          this.isLoading = false;

          if (response.data.status === "SUCCESS") {
            this.showAlert = true;
            this.alertVariant = "success";
            this.alertMessage = `Face scan added successfully for ${response.data.email}`;
            this.email = ""; // Clear the input after success
          } else if (response.data.status === "FAIL") {
            this.showAlert = true;
            this.alertVariant = "warning";
            this.alertMessage = response.data.message;
          } else {
            this.showAlert = true;
            this.alertVariant = "danger";
            this.alertMessage =
              response.data.message || "Failed to add face scan";
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.showAlert = true;
          this.alertVariant = "danger";

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            this.alertMessage = error.response.data.message;
          } else {
            this.alertMessage = "An error occurred while adding face scan";
          }
        });
    },
  },
};
</script>

<style scoped>
.gobutton {
  margin-top: 15px;
  width: 200px;
}

.container {
  max-width: 600px;
}

h3 {
  color: #007bff;
  font-weight: bold;
}
</style>
